<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'leftimgrighttext',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <a-row :gutter="[30,30]">
        <a-col style="box-shadow: rgba(200,200,200,.2) 0 0 1.5px;" :sm="getCol.sm(data.col)" :md="getCol.md(data.col)"  :lg="getCol.lg(data.col)"  v-for="(item,i) in data.child" :key="i">
            <div class="content-box padding flex" >
              <a-image  :src="addip(item.pic)" :alt="item.name" width="30%" />
              <div class="flex1 padding-left">
                <h3 style="">{{ item.name }}</h3>
                <h5 v-if="item.sub">{{ item.sub }}</h5>
                <div class="padding-tb" v-if="item.contents" v-html="item.contents">
                </div>
              </div>
            </div>
        </a-col>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="leftimgrighttext">
import {defineComponent,defineProps } from 'vue'
import {addip,getCol} from '@/utils/util'
defineProps({
  data:Object
})
</script>
